import { createReducer, on } from '@ngrx/store';

import { retrieveSetting, updateSetting, clearSetting, updateTheme, updateCountry, updateChain, updateRestaurant, updateOrderChannels, updateChainTimeZone, updateDisableType, updateDomainURL, updateOrganizationName } from '../actions/setting.action';
import { Setting } from 'src/app/shared/interfaces/setting.interface';

export const initialState: Setting = {
  country_name: '',
  country_id: '',
  chain_name: '',
  chain_id: '',
  restaurant_name: '',
  restaurant_id: '',
  order_channels: [],
  theme: null,
  time_zone: '',
  disable_model_name: '',
  domain_url: '',
  organization_name: ''
};

export const settingReducer = createReducer(
  initialState,
  on(retrieveSetting, (state, { payload }) => payload),
  on(updateSetting, (state, { payload }) => {
    localStorage.setItem('setting-data', JSON.stringify(payload));
    return payload;
  }),
  on(clearSetting, (state) => {
    localStorage.removeItem('setting-data');
    return initialState;
  }),
  on(updateTheme, (state, { theme }) => {
    const payload = { ...state, theme };
    localStorage.setItem('setting-data', JSON.stringify(payload));
    return payload;
  }),
  on(updateCountry, (state, {country_id, country_name}) => {
    const payload = { ...state, country_id, country_name};
    localStorage.setItem('setting-data', JSON.stringify(payload));
    return payload;
  }),
  on(updateChain, (state, {chain_id, chain_name}) => {
    const payload = { ...state, chain_id, chain_name };
    localStorage.setItem('setting-data', JSON.stringify(payload));
    return payload;
  }),
  on(updateRestaurant, (state, {restaurant_id, restaurant_name}) => {
    const payload = { ...state, restaurant_id, restaurant_name };
    localStorage.setItem('setting-data', JSON.stringify(payload));
    return payload;
  }),
  on(updateOrderChannels, (state, {order_channels}) => {
    const payload = { ...state, order_channels };
    localStorage.setItem('setting-data', JSON.stringify(payload));
    return payload;
  }),
  on(updateChainTimeZone, (state, {time_zone}) => {
    const payload = { ...state, time_zone };
    localStorage.setItem('setting-data', JSON.stringify(payload));
    return payload;
  }),
  on(updateDomainURL, (state, {domain_url}) => {
    const payload = { ...state, domain_url };
    localStorage.setItem('setting-data', JSON.stringify(payload));
    return payload;
  }),
  on(updateDisableType, (state, { disable_model_name }) => {
    const payload = { ...state, disable_model_name };
    localStorage.setItem('setting-data', JSON.stringify(payload));
    return payload;
  }),
  on(updateOrganizationName, (state, {organization_name}) => {
    const payload = { ...state, organization_name };
    localStorage.setItem('setting-data', JSON.stringify(payload));
    return payload;
  }),
);
